<footer *transloco="let t; read: 'navigation.footer'">
  <div class="version">v{{ version }}</div>
  <div class="footer-container">
    <div class="column divide">
      <div class="header">{{ t('links') }}</div>
      <a class="link" target="_blank" [href]="t('justice-name-download-link')">{{ t('justice-name') }}</a>
      <a
        *ngIf="languageService.getActiveLang() === 'nl'"
        class="link"
        target="_blank"
        href="https://steunpuntbewindvoering.be/form/informatie"
        >{{ t('steunpunt') }}</a
      >
      <a class="link" target="_blank" [href]="'assets/health_certificate/' + t('health-certificate-file-name')" download>{{
        t('health-certificate')
      }}</a>
      <a
        *ngIf="languageService.getActiveLang() !== 'nl'"
        class="link"
        target="_blank"
        routerLink="/whats-new"
        queryParamsHandling="merge"
        >{{ t('whats-new') }}</a
      >
    </div>
    <div class="column divide">
      <div class="header"></div>
      <a *ngIf="languageService.getActiveLang() === 'nl'" class="link" target="_blank" routerLink="/whats-new" queryParamsHandling="merge">{{ t('whats-new') }}</a>
      <a class="link" target="_blank" routerLink="/help" queryParamsHandling="merge">{{ t('help') }}</a>
    </div>
    <div class="column">
      <div class="header">{{ t('law-info') }}</div>
      <a class="link" [routerLink]="['/terms-of-use']" queryParamsHandling="merge">{{ t('terms-of-use') }}</a>
      <a class="link" [routerLink]="['/privacy-policy']" queryParamsHandling="merge">{{ t('privacy-policy') }}</a>
      <a class="link" [routerLink]="['/accessibility-statement']" queryParamsHandling="merge">{{ t('accessibility-statement') }}</a>
    </div>
    <div class="column fill"></div>
    <div class="column">
      <div class="fill"></div>
      <div class="copyright" [innerHTML]="t('copyright', { currYear: currYear })"></div>
    </div>
  </div>
</footer>
